import React, { useEffect, useRef } from 'react';
import { Text } from 'react-native';
import { TextShadowProps } from './expandable-text-types';
import { useDebouncedCallback } from 'use-debounce';

const RESIZE_DEBOUNCE_DELAY_MS = 250;

export const ExpandableTextShadow: React.FC<TextShadowProps> = ({
  children,
  numberOfLines,
  setCanExpand,
  textStyle,
}) => {
  const textRef = useRef<Text>(null);

  const debouncedResize = useDebouncedCallback(() => {
    if (textRef.current) {
      const node = textRef.current as unknown as HTMLDivElement;
      setCanExpand(node.scrollHeight > node.clientHeight);
    }
  }, RESIZE_DEBOUNCE_DELAY_MS);

  useEffect(() => {
    window.addEventListener('resize', debouncedResize);
    return () => window.removeEventListener('resize', debouncedResize);
    // Register resize listeners only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Text
      numberOfLines={numberOfLines}
      ref={(ref) => {
        textRef.current = ref;
        debouncedResize();

        // Immediately update canExpand
        debouncedResize.flush();
      }}
      style={textStyle}
    >
      {children}
    </Text>
  );
};
